export const env = {
  VITE_APP_API_URL:
    (typeof window === "undefined"
      ? process.env.API_URL
      : import.meta.env.VITE_APP_API_URL) ?? "",
};
